module.exports = __webpack_public_path__ + "img/icon-notice.2978e664.png";